<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [pagingCallState]="pagingCallState"
   [searchText]="searchText"
   [showCreate]="phoneNumberPrivileges?.canAdd"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="accountName" width="6">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="account-name-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="account.name"
               >Account<mat-icon class="mat-icon-sort">{{ getSort('account.name') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <a [routerLink]="getDynamicRouterLink(phoneNumber)">
                  {{ phoneNumber.accountName }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="phoneNumber" width="4">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="phoneNumber-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Asc"
               sortField="phoneNumber"
               >Phone Number<mat-icon class="mat-icon-sort">{{ getSort('phoneNumber') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <div class="phone-number-wrapper">
                  <mat-icon
                     class="small-icon"
                     (click)="
                        copyPhoneNumberToClipboard(phoneNumber.phoneNumber);
                        $event.preventDefault();
                        $event.stopPropagation()
                     "
                  >
                     content_copy
                  </mat-icon>

                  <a [routerLink]="getRouterLink(phoneNumber.phoneNumberId)">
                     {{ phoneNumber.phoneNumber | formatPhoneNumbers }}
                  </a>
               </div>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="providerId" width="4">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="providerId-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="providerId"
               >Provider<mat-icon class="mat-icon-sort">{{ getSort('providerId') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <a [routerLink]="getDynamicRouterLink(phoneNumber)">
                  {{ phoneNumber.providerId }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="isActive" width="4">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="isActive-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="isActive"
               >Active<mat-icon class="mat-icon-sort">{{ getSort('isActive') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <a [routerLink]="getDynamicRouterLink(phoneNumber)">
                  @if (phoneNumber.isActive) {
                  <mat-icon>check</mat-icon>
                  }
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="isPorted" width="4">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="isPorted-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="isPorted"
               >Ported<mat-icon class="mat-icon-sort">{{ getSort('isPorted') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <a [routerLink]="getDynamicRouterLink(phoneNumber)">
                  @if (phoneNumber.isPorted) {
                  <mat-icon>check</mat-icon>
                  }
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="datePorted" width="5">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="datePorted-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="datePorted"
               >Date Ported<mat-icon class="mat-icon-sort">{{ getSort('datePorted') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <a [routerLink]="getDynamicRouterLink(phoneNumber)">
                  {{ phoneNumber.datePorted | date : 'MM/dd/yyyy hh:mm aa' }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="systemPhoneNumberActionsMenu" width="0.75">
            <th lcs-header-cell *lcsHeaderCellDef id="system-phone-number-actions-menu-column-header"></th>
            <td lcs-cell *lcsCellDef="let phoneNumber">
               <button
                  type="button"
                  aria-label="Phone Number Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="systemPhoneNumbersMenu"
                  id="system-phone-number-more-actions"
               >
                  <mat-icon> more_horiz </mat-icon>
               </button>
               <mat-menu #systemPhoneNumbersMenu="matMenu">
                  <a mat-menu-item [routerLink]="getDynamicRouterLink(phoneNumber)"> Details </a>
                  <button type="button" mat-menu-item (click)="copyPhoneNumberToClipboard(phoneNumber.phoneNumber)">
                     Copy Phone Number
                  </button>
                  @if (canRelease(phoneNumber)) {
                  <button
                     mat-menu-item
                     type="button"
                     (click)="onReleaseAccountClick(phoneNumber); $event.preventDefault(); $event.stopPropagation()"
                     id="phone-number-release"
                  >
                     Release Phone Number
                  </button>
                  } @if (canDelete(phoneNumber)) {
                  <button
                     mat-menu-item
                     type="button"
                     (click)="onDeleteClick(phoneNumber); $event.preventDefault(); $event.stopPropagation()"
                     id="phone-number-delete"
                  >
                     Delete Phone Number
                  </button>
                  }
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
